import { render } from "./gift-cards.vue?vue&type=template&id=12173fa1"
import script from "./gift-cards.vue?vue&type=script&lang=js"
export * from "./gift-cards.vue?vue&type=script&lang=js"

import "./gift-cards.vue?vue&type=style&index=0&id=12173fa1&lang=scss"

import exportComponent from "/builds/secur/secur-v2-cloud/portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__